import { buildModelManager } from "../builder.js";
const DefaultAiCreditsTransactionSelection = {
  __typename: true,
  id: true,
  conversationId: true,
  createdAt: true,
  delta: true,
  inputTokens: true,
  kind: true,
  outputTokens: true,
  profileId: true,
  reason: true,
  stripePaymentIntentId: true,
  updatedAt: true,
  upstreamModel: true,
  userId: true,
  wholesaleCostPence: true
};
const modelApiIdentifier = "aiCreditsTransaction";
const pluralModelApiIdentifier = "aiCreditsTransactions";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiCreditsTransactionSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "aiCreditsTransactionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AiCreditsTransactionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAiCreditsTransactionSelection,
  operations
);
export {
  AiCreditsTransactionManager,
  DefaultAiCreditsTransactionSelection
};
//# sourceMappingURL=AiCreditsTransaction.js.map
